import "lodash";
import { svc_search, svc_addOne, svc_editOne, svc_fetchAll } from "@/services/";
import { svc_getAllPolicyGroups } from "@/services/policygroup";
import logger from "@/utils/logger";
import { convertISODateTimeToString } from "@/utils/convertTime";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "policy_group";

const Model = {
	namespace: "m_PolicyGroup",
	state: {
		policyGroup: [],
	},
	reducers: {
		updateModelState(state, { payload: { response } }) {
			return { ...state, policyGroup: response };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			// pagination for policy groups crudtable
			let response = yield call(svc_search, endpointBasePrefix, payload);
			if (!showServerResponse(response, true));

			logger("** @effects - fetchAll: " + JSON.stringify(response), 6);
			_.forEach(response.result, (row) => {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["created_at"]);
			});
			yield put({
				type: "updateModelState",
				payload: { response },
			});
			return response;
		},
		*fetchSelectSearch({ payload }, { call, put }) {
			// get full list of policy groups for staff MIF policy group field
			let response = yield call(svc_getAllPolicyGroups, endpointBasePrefix, { search: payload.policy_group });
			if (!showServerResponse(response, true));

			logger("** @effects - fetchAll: " + JSON.stringify(response), 5);
			_.forEach(response.result, (row) => {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["created_at"]);
			});
			console.log(response)
			yield put({
				type: "updateModelState",
				payload: { response },
			});
			return response;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			return showServerResponse(response);
		},
	},
};

export default Model;
